module.exports = __webpack_public_path__ + "img/triangle3blue.b45b8def.png";